export default {
  loading: {
    id: 'bo_seller.homepage.loading',
    defaultMessage: 'Loading...',
  },
  wallet: {
    id: 'bo_seller.homepage.wallet',
    defaultMessage: 'Wallet',
  },
  viewDetails: {
    id: 'bo_seller.homepage.wallet.view_details',
    defaultMessage: 'View details',
  },
  totalAmount: {
    id: 'bo_seller.homepage.wallet.total_amount',
    defaultMessage: 'Total amount',
  },
  nextPayout: {
    id: 'bo_seller.homepage.wallet.next_payout',
    defaultMessage: 'Next payout: {date}',
  },
  salesPeriod: {
    id: 'bo_seller.homepage.wallet.sales_period',
    defaultMessage: 'Sales period: {range}',
  },
  currency: {
    id: 'bo_seller.homepage.wallet.currency',
    defaultMessage: 'Currency',
  },
  noUpcomingPayout: {
    id: 'bo_seller.homepage.wallet.no_upcoming_payout',
    defaultMessage: 'No upcoming payout',
  },
}
